import gql from 'graphql-tag';

const GET_CURRENT_USER = gql`
  query getCurrentUser {
    getCurrentUser {
      userId
      firstName
      lastName
      email
      name
      phoneNumber
      splashtopWFHEnabled
      remoteDesktopAddOnEnabledStatus
      customer {
        source {
          name
        }
        collectProfile
      }
      role {
        roleId
        name
        description
        roleType {
          name
        }
        editable
        creationType
        roleFeatureList {
          feature {
            featureId
            key
          }
          operationList {
            operationId
            name
            value
          }
        }
      }
      site {
        account {
          accountId
          name
        }
        countryCode
      }
      account {
        accountType
      }
      accountType
      subscriptionStatus
      trialExpiryDays
      chargeBeePlanId
      customer {
        source {
          name
        }
      }
      customerId
      domain
      mspName
      mspLogoFileName
      associations {
        client {
          accountId
          name
        }
      }
      calendarIntegrated
    }
  }
`;
const GET_LOGIN_CONTEXT_USER = gql`
  query getLoggedInContext {
    getLoggedInContext {
      customer {
        customerId
        signupEmailId
        checkoutProgressState
        source {
          name
        }
        collectProfile
      }
      organizationContext {
        numberFormat {
          country
          currency
          language
        }
        name
        logoFileName
        currency
        language
        dateFormat
        timeFormat
        baseDomain
        portalDomains {
          domainId
          domainName
          type
          isDefault
        }
      }
      subscriptionContext {
        subscriptionStatus
        activatedDateTime
        daysSinceActivated
        trialExpiryDays
        chargeBeePlanId
        planName
      }
      hqSiteContext {
        timezoneCode
        working24x7
        businessHour {
          day
          start
          end
        }
        countryCode
      }
      user {
        userId
        firstName
        lastName
        email
        name
        idpSubjectIdentifier
        phoneNumber
        emailSignature
        loginRequired
        contactNumber
        contactType
        authenticated
        designation {
          designationId
          name
        }
        businessFunction {
          businessFunctionId
          name
        }
        team {
          teamId
          name
        }
        groups {
          groupId
          name
        }
        splashtopWFHEnabled
        remoteDesktopAddOnEnabledStatus
        roles {
          roleId
          name
          description
          roleType {
            name
            type
          }
          editable
          creationType
          roleFeatureList {
            feature {
              featureId
              key
            }
            operationList {
              operationId
              name
              value
            }
          }
        }
        site {
          account {
            accountId
            name
          }
          countryCode
        }
        account {
          accountType
        }
        accountType
        customerId
        domain
        mspName
        associations {
          client {
            accountId
            name
          }
          org {
            clientOrg
            companyOrg
            name
            accountId
          }
          site {
            name
            id
          }
        }
        calendarIntegrated
      }
      rmmAppProperties
    }
  }
`;

const GET_NON_AUTH_LANGUAGE = gql`
  query getLoggedInContext {
    getLoggedInContext {
      hqSiteContext {
        timezoneCode
        working24x7
        businessHour {
          day
          start
          end
        }
        countryCode
      }
      organizationContext {
        numberFormat {
          country
          currency
          language
        }
        name
        logoFileName
        currency
        language
        dateFormat
        timeFormat
        baseDomain
        portalDomains {
          domainId
          domainName
          type
          isDefault
        }
      }
    }
  }
`;

const GET_THIRD_PARTY_KEY = gql`
  query getCurrentUserThirdPartyHashKey {
    getCurrentUserThirdPartyHashKey
  }
`;

// enum SubscriptionStatus {
//   ACTIVE,
//   TRIAL,
//   TRIAL_EXPIRED,
//   NON_RENEWING,
//   PAUSED,
//   CANCELLED
// }

export {
  GET_CURRENT_USER,
  GET_THIRD_PARTY_KEY,
  GET_LOGIN_CONTEXT_USER,
  GET_NON_AUTH_LANGUAGE
};
